import { ChatMessageType } from 'models/chatMessage';
import React from 'react';
import ShareBetMessage from './ShareBetMessage';
import { FaFileAlt } from 'react-icons/fa';
import FileSaver from 'file-saver';
import GiveAwayMessage from './GiveAwayMessage';
import { uniqueId } from 'utils/commonUtils';
import { useAppSelector } from 'app/hooks';
import { selectShowChatMobile } from 'redux/chatSlice';

interface RenderMeassageProps {
  chat: ChatMessageType;
  myMessage: boolean;
}

const RenderMeassage: React.FunctionComponent<RenderMeassageProps> = ({ chat, myMessage }) => {
  const selectedShowChatMobile = useAppSelector(selectShowChatMobile);
  const handleDownload = (fileUrl: string, fileName: string) => {
    FileSaver.saveAs(fileUrl, fileName);
  };
  // Render based on the message type
  const renderMessageContent = () => {
    switch (chat.messageType) {
      case 'SHARE_BET':
        return <ShareBetMessage message={JSON.parse(chat.message)} myMessage={myMessage} />;
      case 'IMAGE':
        return (
          <img
            src={chat.fileUrl}
            alt="TERABET"
            className={`image-message ${selectedShowChatMobile ? 'image-message-mobile' : ''} `}
          />
        );
      case 'FILE':
        return (
          <div onClick={() => handleDownload(chat.fileUrl, chat.fileName)} className="file-massage">
            <FaFileAlt />
            <span>{chat.fileName}</span>
          </div>
        );
      case 'GIVE_AWAY':
        return <GiveAwayMessage message={JSON.parse(chat.message)} />;
      case 'NEWS':
        const parsedArray = JSON.parse(chat.message);
        try {
          const msg = JSON.parse(parsedArray);
          return <RenderNews news={msg} />;
        } catch (error) {
          return null;
        }
      default:
        return <span>{chat.message}</span>; // Render message or a fallback
    }
  };

  return <>{renderMessageContent()}</>;
};

type MessageNews = {
  title: string;
  link: string;
  date: string;
};
interface RenderNewsProps {
  news: MessageNews[];
  isReply?: boolean;
}
export const RenderNews: React.FunctionComponent<RenderNewsProps> = (props) => {
  return (
    <div className="news-message">
      {props?.news?.map((item, index) => (
        <div key={uniqueId()} className="news-message__item">
          {props.isReply ? (
            <span>
              {' '}
              <b>{`${index + 1}. `}</b>
              {item.title}
            </span>
          ) : (
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              <b>{`${index + 1}. `}</b>
              {item.title}
            </a>
          )}
        </div>
      ))}
    </div>
  );
};

export default RenderMeassage;
